import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App'; // Our main router container
import '../src/app.css'; // or a separate CSS file

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
